/**
 * @generated SignedSource<<859ca46fe8df6795dae4522dcb4b0919>>
 * @relayHash ff40e1ab26f1c562eb7aca5b39c2cd1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 711c0cbe492f8ddfcdd6a0c1de131125b9d0b94e804eb2b2219f9761c68845a5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraLongRunningTaskStatus = "CANCELLED" | "CANCEL_REQUESTED" | "COMPLETE" | "DEAD" | "ENQUEUED" | "FAILED" | "RUNNING" | "%future added value";
export type ProgressPollingQuery$variables = {
  cloudId: string;
  taskId: string;
};
export type ProgressPollingQuery$data = {
  readonly jira: {
    readonly bulkOperationProgress: {
      readonly progress: AGG$Long | null | undefined;
      readonly status: JiraLongRunningTaskStatus | null | undefined;
      readonly taskId: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ProcessResponse">;
    } | null | undefined;
  } | null | undefined;
};
export type ProgressPollingQuery = {
  response: ProgressPollingQuery$data;
  variables: ProgressPollingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "taskId",
    "variableName": "taskId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "progress"
},
v3 = {
  "kind": "ScalarField",
  "name": "taskId"
},
v4 = {
  "kind": "ScalarField",
  "name": "status"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProgressPollingQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueBulkOperationProgress",
            "kind": "LinkedField",
            "name": "bulkOperationProgress",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ProcessResponse"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProgressPollingQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssueBulkOperationProgress",
            "kind": "LinkedField",
            "name": "bulkOperationProgress",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "totalIssueCount"
              },
              {
                "concreteType": "JiraIssueBulkOperationFailureConnection",
                "kind": "LinkedField",
                "name": "failedAccessibleIssues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueBulkOperationFailureEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueBulkOperationFailure",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "711c0cbe492f8ddfcdd6a0c1de131125b9d0b94e804eb2b2219f9761c68845a5",
    "metadata": {},
    "name": "ProgressPollingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d38af32b8a848e60dd563ef087a50b73";

export default node;
